import { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";
import { StatCard } from "@/components/app/UI";
import { TYPE_LABEL, fmtDays } from "@/components/leave/shared";

const List = ({ title, rows, testid }) => (
  <div className="flat-card p-5" data-testid={testid}>
    <div className="label-eyebrow mb-3">{title} ({rows.length})</div>
    {rows.length === 0 && <div className="text-sm text-[#9CA3AF]">Nobody.</div>}
    <div className="divide-y divide-[#F3F4F6]">
      {rows.map((a) => (
        <div key={a.id} className="py-2 text-sm flex justify-between gap-3">
          <span className="font-bold">{a.employee_name} <span className="text-[#9CA3AF] font-normal">{a.department || ""}</span></span>
          <span className="text-xs text-[#4B5563] whitespace-nowrap">{a.leave_type} · {fmtDate(a.from_date)} – {fmtDate(a.to_date)} · {fmtDays(a.days)}d</span>
        </div>
      ))}
    </div>
  </div>
);

export const HrDashboard = ({ goTo }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/leave/dashboard").then((r) => setD(r.data)).catch(() => setD(false)); }, []);
  if (d === false) return <div className="text-sm text-[#B91C1C]">Could not load the dashboard.</div>;
  if (!d) return <div className="text-sm text-[#9CA3AF]">Loading…</div>;
  return (
    <div className="space-y-4" data-testid="hr-dashboard">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard label="Total Employees" value={d.total_employees} testid="hr-stat-employees" />
        <StatCard label="On Leave Today" value={d.on_leave_today.length} accent="warning" testid="hr-stat-today" />
        <StatCard label="Upcoming Approved Leave" value={d.upcoming_count} accent="success" testid="hr-stat-upcoming" />
        <button className="text-left" onClick={() => goTo("applications")} data-testid="hr-stat-pending-btn">
          <StatCard label="Pending Applications" value={d.pending_count} sub={d.cancellation_requests ? `${d.cancellation_requests} cancellation request(s)` : undefined} accent="danger" testid="hr-stat-pending" />
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {Object.entries(d.taken).map(([t, v]) => (
          <StatCard key={t} label={`${TYPE_LABEL[t]} Taken`} value={fmtDays(v)} sub={`Leave year ${fmtDate(d.year.start)} – ${fmtDate(d.year.end)}`} testid={`hr-stat-taken-${t}`} />
        ))}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <List title="On Leave Today" rows={d.on_leave_today} testid="hr-list-today" />
        <List title="Upcoming Approved Leave" rows={d.upcoming} testid="hr-list-upcoming" />
      </div>
    </div>
  );
};
